import { Component, EventEmitter, Input, Output } from "@angular/core";
@Component({
    selector: 'paginador',
    templateUrl: './paginador.component.html',
    styleUrl: './paginador.component.scss'
})
export class PaginadorComponent {

    private _paginas: number[];
    private _seleccionada: number = 1;
    @Output() cambioPagina = new EventEmitter();

    constructor() {
        this._paginas = [
            1, 2, 3, 4, 5
        ]
    }

    seleccionPagina(pagina: number) {
        if (pagina == 0 || pagina > this._paginas.length) {
            return;
        }
        this.cambioPagina.emit(pagina);
    }

    get paginas(): number[] {
        return this._paginas;
    }

    get seleccionada(): number {
        return this._seleccionada;
    }

    @Input() set paginas(value: number[]) {
        this._paginas = value;
    }

    @Input() set seleccionada(value: number) {
        this._seleccionada = value;
    }
}